// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* App level primary color */
  --primary-color: #1a64af;
  /* App level primary color */

  --pure-white-color: #ffffff;
  --black-color : #03080D;
  --silver-color: #efefef;
  --grey-color: #797979;
  --emarald-green-color: #58b647;
  --aqua-color : rgb(233, 249, 255);
  --light-grey-color : #F6F6F6;

  --primary-container-max-width: 1440px;
  --default-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1),
    0 2px 7px 0 rgba(0, 0, 0, 0.1);

  /* Font style variables */
  --font-style-normal: normal;

  /* Font size, font family and font weight variables */
  --default-font-family: Poppins, sans-serif;
  --font-family-lato: Lato;

  --font-size-10: 10px;
  --font-size-11: 11px;
  --font-size-12: 12px;
  --font-size-13: 13px;
  --font-size-14: 14px;
  --font-size-15: 15px;
  --font-size-16: 16px;
  --font-size-17: 17px;
  --font-size-18: 18px;
  --font-size-24: 24px;
  --font-size-28: 28px;
  --font-size-40: 40px;

  --font-weight-400: 400;
  --font-weight-500: 500;
  --font-weight-600: 600;
  --font-weight-700: 700;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/variables.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,4BAA4B;;EAE5B,2BAA2B;EAC3B,uBAAuB;EACvB,uBAAuB;EACvB,qBAAqB;EACrB,8BAA8B;EAC9B,iCAAiC;EACjC,4BAA4B;;EAE5B,qCAAqC;EACrC;kCACgC;;EAEhC,yBAAyB;EACzB,2BAA2B;;EAE3B,qDAAqD;EACrD,0CAA0C;EAC1C,wBAAwB;;EAExB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;;EAEpB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;AACxB","sourcesContent":[":root {\n  /* App level primary color */\n  --primary-color: #1a64af;\n  /* App level primary color */\n\n  --pure-white-color: #ffffff;\n  --black-color : #03080D;\n  --silver-color: #efefef;\n  --grey-color: #797979;\n  --emarald-green-color: #58b647;\n  --aqua-color : rgb(233, 249, 255);\n  --light-grey-color : #F6F6F6;\n\n  --primary-container-max-width: 1440px;\n  --default-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1),\n    0 2px 7px 0 rgba(0, 0, 0, 0.1);\n\n  /* Font style variables */\n  --font-style-normal: normal;\n\n  /* Font size, font family and font weight variables */\n  --default-font-family: Poppins, sans-serif;\n  --font-family-lato: Lato;\n\n  --font-size-10: 10px;\n  --font-size-11: 11px;\n  --font-size-12: 12px;\n  --font-size-13: 13px;\n  --font-size-14: 14px;\n  --font-size-15: 15px;\n  --font-size-16: 16px;\n  --font-size-17: 17px;\n  --font-size-18: 18px;\n  --font-size-24: 24px;\n  --font-size-28: 28px;\n  --font-size-40: 40px;\n\n  --font-weight-400: 400;\n  --font-weight-500: 500;\n  --font-weight-600: 600;\n  --font-weight-700: 700;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
